@if(field){
<div [formGroup]="form" class="field-container">
  <mat-form-field class="dynamic-mat-form-field" appearance="outline">
    <mat-label [class.field-label--disabled]="form.get(field['fieldName'])?.disabled">{{field.camelCase ? field["displayName"] :( field["displayName"] | camelCase)}}</mat-label>
    <textarea [id]="field['fieldName']" matInput (keyup)="onTextChange(field['fieldName'], $event)"
      [attr.maxlength]="field.max" matInput [formControlName]="field['fieldName']"
      [value]="field.selectedValue" ></textarea>
    @if(form.get(field['fieldName'])?.hasError('required')&& form.get(field['fieldName'])?.touched){
    <mat-error> {{field.displayName | camelCase}} is required</mat-error>
    }
    @if(form.get(field['fieldName'])?.hasError('email')&& form.get(field['fieldName'])?.touched){
    <mat-error> Please enter valid {{field.displayName | camelCase}} </mat-error>
    }
  </mat-form-field>
</div>
}